import { UseFormReturn, useWatch } from "react-hook-form";

import { useTranslation } from "../../core/translation.core";
import useRetailList from "../../hooks/useRetailList.hook";
import { FancyCheckbox } from "../reuseables/form.comp";
import { selectCss } from "../reuseables/native.comp";

export default function ExcludePlacementEditor({ methods }: { methods: UseFormReturn<any, any> }) {
  const { t, msg } = useTranslation();
  const { data: retailShops } = useRetailList();

  const [excludePlacement, excludeLocation] = useWatch({
    name: ["excludePlacement", "excludePlacementLocation"], //
    control: methods.control,
  });

  return (
    <div>
      <h2 className="font-bold">Placement</h2>
      <div className="space-y-4">
        <FancyCheckbox value={true} register={methods.register("excludePlacement")}>
          Exclude Placement
        </FancyCheckbox>

        {excludePlacement ? (
          <div>
            <select
              className={selectCss}
              {...methods.register("excludePlacementLocation", {
                onChange: (e) => {
                  if (e.target.value === "eshop") methods.setValue("excludePlacementRetailIds", []);
                },
              })}
            >
              <option value="eshop">{t(msg.placement.eshop)}</option>
              <option value="retail">{t(msg.placement.retail)}</option>
              <option value="both">{t(msg.placement.both)}</option>
            </select>
          </div>
        ) : null}

        {excludePlacement && ["retail", "both"].includes(excludeLocation) ? (
          <div>
            <h2>Select Locations to Exclude</h2>
            {retailShops?.map((k) => (
              <FancyCheckbox
                key={k.id}
                value={k.id}
                register={methods.register("excludePlacementRetailIds")}
                labelId="label-cash"
              >
                {k.name}
              </FancyCheckbox>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
